export default "https://fd.2ng.ru"